import React, { useEffect } from 'react';

import { useDispatch } from 'react-redux';

import femtasyLocalStorage from 'helpers/femtasyLocalStorage';

import { FEMTASY_AUTOPLAY, setAutoplay } from 'store/modules/player';

import AudioSourceSetup from './AudioSourceSetup';
import MatomoHandler from './MatomoHandler';
import SeekHandler from './SeekHandler';

const ConnectedAudioPlayer = () => {
  const audioRef = React.useRef<HTMLAudioElement>(null); // Keep like this so it can be mocked in tests

  const dispatch = useDispatch();

  useEffect(() => {
    femtasyLocalStorage.getItem(FEMTASY_AUTOPLAY).then((autoplay) => {
      dispatch(setAutoplay(autoplay === null ? true : autoplay));
    });
  }, [dispatch]);

  return (
    <>
      <audio
        className="connectedAudioPlayerAudioTag"
        ref={audioRef}
        crossOrigin="use-credentials"
      />
      <MatomoHandler ref={audioRef} />
      <AudioSourceSetup ref={audioRef} />
      <SeekHandler ref={audioRef} />
    </>
  );
};

export default ConnectedAudioPlayer;
